import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import TaxonomyManager, { type TaxonomyItem } from '@/components/admin/TaxonomyManager'

type Props = {
  constant_causes: string[]
  pending: TaxonomyItem[]
  official: TaxonomyItem[]
}

export default function AdminCausesIndex({ constant_causes, pending, official }: Props) {
  return (
    <>
      <Head title="Admin - Causes" />
      <TaxonomyManager
        title="Causes"
        description="Manage the official list of causes and review pending submissions from users and organizations."
        resourcePath="/admin/causes"
        paramKey="cause"
        baseConstants={constant_causes}
        pending={pending}
        official={official}
        addLabel="Add cause"
        addPlaceholder="e.g., Climate Justice"
      />
    </>
  )
}

AdminCausesIndex.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
